import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  text,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'
import toast from '@groovehq/internal-design-system/lib/components/Toast'

import { string, bool } from 'prop-types'
import { selectCurrentAgentById } from 'ducks/agents/selectors'
import { doChangeToAgent } from 'ducks/agents/operations'
import { emptyFunc } from 'util/functions'

import EntityDeleteDrawer from '../EntityDelete'
import TeammatesRemovalLock from '../../TeammatesRemovalLock'

const AgentRemoveAdmin = props => {
  const {
    title,
    open,
    drawerResourceId: agentId,
    onClose,
    onExit,
    onRemove,
  } = props

  const dispatch = useDispatch()
  const [openLockCard, setOpenLockCard] = useState(false)

  const agent = useSelector(state => selectCurrentAgentById(state, agentId))

  const handleOnRemove = useCallback(
    async () => {
      try {
        await dispatch(
          doChangeToAgent(agentId, { throwOnError: true, toastsEnabled: false })
        )
        if (onRemove) onRemove(agentId)
        toast.notify({
          content: 'Access granted',
          type: 'positive',
        })
        onExit({ isAfterDelete: true })
      } catch (e) {
        if (e.activity && e.activity[0]?.includes('irregular activity')) {
          setOpenLockCard(true)
        } else {
          toast.notify({
            content: `${app.t('Agent')} action failed`,
            type: 'negative',
          })
          onExit({ isAfterDelete: true })
        }
      }
    },
    [dispatch, agentId, onRemove, onExit]
  )

  const handleCloseRemovalLock = useCallback(
    () => {
      setOpenLockCard(false)
      onExit({ isAfterDelete: true })
    },
    [onExit]
  )

  if (!agent) return null

  const { email } = agent

  return (
    <>
      {!openLockCard && (
        <EntityDeleteDrawer
          {...props}
          onRemove={handleOnRemove}
          onClose={emptyFunc}
          onCancel={onClose}
          title={title}
          deleteBtnText="Remove admin access"
          deletingBtnText="Removing admin access..."
          tertiaryBtnText="Cancel"
          open={open}
        >
          <div className="grui mt-7">
            <div css={text.styles.textNormal}>
              <p css={[paragraph.styles.preflight, text.styles.fontMedium]}>
                You are about to remove admin access for {email}.
              </p>
              <br />
              <p css={paragraph.styles.preflight}>
                The {app.t('agent')} will lost the ability to perform all
                admin-level actions.
              </p>
            </div>
          </div>
        </EntityDeleteDrawer>
      )}
      <TeammatesRemovalLock
        onExit={handleCloseRemovalLock}
        open={openLockCard}
      />
    </>
  )
}

AgentRemoveAdmin.propTypes = {
  title: string,
  open: bool.isRequired,
  drawerResourceId: string,
}

AgentRemoveAdmin.defaultProps = {
  title: 'Remove admin access',
  drawerResourceId: '',
}

export default AgentRemoveAdmin
